import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Form, Button, Message } from 'semantic-ui-react';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import {
  showEditPriceModal,
  updateAddonProductPrice,
} from 'state/additionalService/actions';
import ValidatedFormInput from 'components/ValidatedFormInput';

const validate = values => {
  const errors = {};

  if (!values.price_per_unit) {
    errors.price_per_unit = 'Price is required';
  } else if (values.price_per_unit <= 0) {
    errors.price_per_unit = 'Price must be greater than 0';
  }

  return errors;
};

export class PriceEditorModal extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  onClose() {
    const { dispatch, reset } = this.props;
    dispatch(showEditPriceModal(false, null));
    reset();
  }

  onSubmit(values) {
    const errors = validate(values);

    if (Object.keys(errors).length > 0) {
      throw new SubmissionError(errors);
    }

    const { dispatch, editingProduct } = this.props;
    const payload = {
      ...editingProduct,
      price_per_unit: parseFloat(values.price_per_unit),
    };

    const excludeKeys = ['tax', 'discount_rule', 'created_at', 'updated_at'];
    const cleanedPayload = Object.entries(payload)
      .filter(([key, value]) => value !== null && !excludeKeys.includes(key))
      .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

    return dispatch(updateAddonProductPrice(editingProduct.id, cleanedPayload));
  }

  render() {
    const {
      isOpen,
      isLoading,
      errorMessage,
      handleSubmit,
      editingProduct,
    } = this.props;

    return (
      <Modal open={isOpen} onClose={this.onClose} size="tiny">
        <Modal.Header>Edit Price</Modal.Header>
        <Modal.Content>
          {errorMessage && (
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{errorMessage}</p>
            </Message>
          )}
          <Form onSubmit={handleSubmit(this.onSubmit)} loading={isLoading}>
            <Form.Field>
              <label>
                Modular Product: {editingProduct && editingProduct.name}
              </label>
            </Form.Field>
            <Field
              name="price_per_unit"
              component={ValidatedFormInput}
              label="Price (Rp)"
              type="number"
              step="1"
              min="0"
              placeholder="Enter price"
              required
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            primary
            onClick={handleSubmit(this.onSubmit)}
            loading={isLoading}
            disabled={isLoading}
          >
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

PriceEditorModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  editingProduct: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
};

PriceEditorModal.defaultProps = {
  isOpen: false,
  isLoading: false,
  errorMessage: null,
  editingProduct: null,
};

const mapStateToProps = state => ({
  isOpen: state.additionalService.priceEditor.isOpen,
  isLoading: state.additionalService.priceEditor.isLoading,
  errorMessage: state.additionalService.priceEditor.errorMessage,
  editingProduct: state.additionalService.priceEditor.editingProduct,
  initialValues: {
    ...state.additionalService.priceEditor.editingProduct,
  },
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'priceEditorForm',
    enableReinitialize: true,
  })(PriceEditorModal)
);
